import React from 'react'
import './App.css'

function Menu () {
    return (
        <div className='menu'>
           <h1>Word of the Day</h1> 
        </div>
    )
}
export default Menu;